import { apiCall } from "./common/base.service"
import config from "../config/application"
import permission from "./permissions.service"
import dictionary from "../config/dictionary"
//url
const findData = "/find"
const uploadData = "/upload"
const sendEmail = "sendEmail"
const deleteFile = "/delete"
class FileUploadService {
  async getFilesByArea(data) {
    const url = `${config.data.providers.fileUpload.url}${findData}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await fileUploadService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.list
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, data)
  }
  async uploadData(data) {
    const url = `${config.data.providers.fileUpload.url}${uploadData}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await fileUploadService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.add
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, data)
  }
  downloadFile = async request => {
    const url = `${config.data.providers.fileUpload.url}/download?filePath=${request}`
    return apiCall("get", url)
  }
  async sendEmail(body) {
    const url = `${config.data.providers.notificationEmail.url}${sendEmail}`
    return apiCall("post", url, body)
  }
  async deleteFileService(body) {
    const url = `${config.data.providers.fileUpload.url}${deleteFile}`
    return apiCall("post", url, body)
  }
  getPermissions = (username, action) => {
    return permission.validPermission(
      process.env.REACT_APP_TRANSACTION_UPLOAD,
      username,
      process.env.REACT_APP_SYSTEM_CODE,
      action
    )
  }
}
const fileUploadService = new FileUploadService()
export default fileUploadService
